import type { FaireProductEntity } from "../../entity_types/product";

export const p_6kmhwqbx7l: FaireProductEntity = {
  token: "p_6kmhwqbx7l",
  type: "product",
  name: "Pencil Lined Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e3f47aa07b2452f3e83ef664e9927d79d96370a98c865ef5213eca7f1e5dba06.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78b364945d598c70238dd0f75da154e6327b5e0e6e032eb402d8f3c282f3fa70.png",
    "https://cdn.faire.com/fastly/7ac327dd5ec5f3ee3c654dc81d7d0a96c09f59b20f7fe3e1e726bdfe8e4c16c4.png",
    "https://cdn.faire.com/fastly/6c8c4b72fa7bba3d997b411b3c0a4d9061213b0e3c2a3cb8979c8e2829036f1f.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
  ],
  priceDollars: 9,
  description:
    "We're partial to luscious, substantial notepads. We want your pen to have a racy affair with your paper everyday. We want list-making, doodling, and note-taking to feel good. AND we want them to be made from recycled paper!\n\n\n5.5 x 8.5 inches\n70# bright white stock\n100 glorious pages\nDouble thick chipboard backing\n\nMade in the USA.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:43.594Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
